/* global Blockly */

import React from 'react';
import AsyncResponseValueStatementCore from '../../helpers/AsyncResponseValueStatementCore';

export const GEOLOCATION_VALUE_OPTIONS = [
    ['Address', 'address'],
    ['Area', 'areaName'],
    ['City', 'cityName'],
    ['State', 'stateName'],
    ['Country', 'countryName'],
    ['PostalCode', 'pincode'],
    ['CountryCode', 'countryCode'],
    ['Latitude', 'latitude'],
    ['Longitude', 'longitude']
];

export const BLOCK_NAME = 'snap_address_getgeolocation';

function defineBlock(context) {
    let prop = {...context};
    prop.tooltipText = "Get current device geolocation value.";
    prop.responseText = "location value";
    prop.responseBlockType = "text_response";
    prop.blockColor = Blockly.Msg.WIDGET_VALUES_HUE;
    prop.helpAnchor = '#address';
    let blockInstance = AsyncResponseValueStatementCore(prop);

    Object.assign(blockInstance, {
        addFields: function() {
            this.appendDummyInput()
                .appendField("get geolocation")
                .appendField(new Blockly.FieldDropdown(GEOLOCATION_VALUE_OPTIONS), "VALUE_KEY");
        }
    });

    return blockInstance;
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let coreResponseCode = block.getJavascriptCore();
            let valueKey = block.getFieldValue("VALUE_KEY");
            return `Snap.geolocation.getValue('${valueKey}', ${coreResponseCode});\n`;
        }
    }
}

const GetGeolocation = function (props) {
    const name = BLOCK_NAME;
    GetGeolocation.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

export default GetGeolocation;
